module.exports = __webpack_public_path__ + "static/img/yunsheng02.ae0abfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunsheng02.jpg
// module id = fQeS
// module chunks = 0